import { render, staticRenderFns } from "./ResetAturUlang.vue?vue&type=template&id=afe374fc&scoped=true"
import script from "./ResetAturUlang.vue?vue&type=script&lang=js"
export * from "./ResetAturUlang.vue?vue&type=script&lang=js"
import style0 from "./ResetAturUlang.vue?vue&type=style&index=0&id=afe374fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe374fc",
  null
  
)

export default component.exports